<template>
  <div id="page">
    <Header />

    <div class="section" id="cta">
      <div class="left">
        <h1>The Future of Modeling</h1>
        <p>Ditch the spreadsheets for a new way to build, understand, and share models</p>
        <router-link tag="button" to="/model">Explore Models</router-link>
      </div>
      <div class="right">
        <TimeSeriesGraph
          v-if="data"
          :datas="data"
          :showTitle="false"
          :showLegend="false"
        />
      </div>
    </div>

    <div class="section" id="data">
      <div class="left">
        <img src="@/assets/images/Data Transformation.svg" width="75%" />
      </div>
      <div class="right">
        <h3>Leverage a range of curated data</h3>
        <p>Use our growing collection of data to get right to modeling
           or soon bring your own data</p>
      </div>
    </div>

    <div class="section" id="structure">
      <div class="left">
        <h3>Structure the relationships between data</h3>
        <p>Build complex interactions and models from the variety
           of potential relationships between data</p>
      </div>
      <div class="right">
        <ModelDAGVisualization
          v-if="isLoaded"
          :graphWidth="350" :graphHeight="100" :staticColoring="true"
          :model="model"
          :key="model.label"
          @input="selectLabels($event)"
        />
      </div>
    </div>

    <div class="section" id="forecast">
      <div class="left">
        <MethodSelector
          v-if="method"
          :method="method" @changeMethod="updateMethod($event)"
          :scenarios="scenarios" @adjustParams="updateScenario($event)"
          :inputMapping="methodInputs" @reorder="updateInputMapping($event)"        
        />
      </div>
      <div class="right">
        <h3>Forecast, inspect, and analyze the models</h3>
        <p>Use a variety of methods and tools to understand
           the models and create your own forecasts</p>
      </div>
    </div>

    <div class="section" id="email">
      <EmailCollection />
    </div>
    
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import EmailCollection from '@/components/layout/EmailCollection';
import TimeSeriesGraph from '@/components/model/TimeSeriesGraph';
import ModelDAGVisualization from '@/components/model/ModelDAGVisualization';
import MethodSelector from '@/components/model/MethodSelector';

import { TimeSeries } from '@/js/model/DataSeries';
import { Model } from '@/js/model/Model';
import { sum } from '@/js/model/Functions';

import { mapState, mapGetters, mapMutations } from 'vuex';

const d3 = require('d3');


export default {
  name: 'HomePage',
  components: {
    Header,
    Footer,
    EmailCollection,
    TimeSeriesGraph,
    ModelDAGVisualization,
    MethodSelector
  },
  mounted() {
    // Create a fake time series of the last hour
    let now = d3.timeMinute();
    let hourBack = d3.timeHour.offset(now, -1);
    let dates = d3.timeMinutes(hourBack, now, 1);

    let seriesA = new TimeSeries(dates.map(d => [d, Math.random()*2+5]));
    let seriesB = new TimeSeries(dates.map(d => [d, Math.random()*4+3]));

    let model = new Model('Home Example');
    let inputAComponent = model.addComponent('Input A');
    inputAComponent.setData(seriesA);
    let inputBComponent = model.addComponent('Input B');
    inputBComponent.setData(seriesB);
    let outputComponent = model.addComponentWithMethod('Output', sum, {args: ['Input A','Input B']});

    model.layout.updateAttributes({
      'dagWidth': 350,
      'dagHeight': 200
    });

    model.recalculate();

    this.exampleModel = model;
    this.setState({model: this.exampleModel});
    this.selectLabels(['Output']);
  },
  watch: {
    $route(to, from) {
      this.setState({model: this.exampleModel});
      this.selectLabels(['Output']);
    }
  },
  computed: {
    ...mapState(['model','isLoaded']),
    ...mapGetters(['data','method','methodInputs','scenarios']),
  },
  methods: {
    ...mapMutations(['setState','selectLabels','updateInputMapping','updateMethod','updateScenario'])
  }
}
</script>

<style scoped>
* >>> .line-number-1 {
  stroke: white;
}
* >>> .line-number-2 {
  stroke: #ff7f45;
  stroke-width: 2;
}

button {
  font-size: 1em;
  background-color: #00bc83;
  border: solid 1px black;
  border-radius: 3px;
}

#page {
  display: flex;
  flex-direction: column;
  font-size: 1em;
}

#cta {
  padding: 1% 0 3% 0;
  border-bottom: solid 1px #000000;
  background-color: #0666B4;
  color: #ffffff;
}

#email {
  width: 100%;
}

.section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  width: 100%;
  min-height: 200px;
}
.section p {
  width: 75%;
  margin-left: auto;
  margin-right: auto;
}

.left {
  width: 100%;
  padding-left: 5%;
}
.right {
  width: 100%;
  padding-right: 5%;
}

@media only screen and (max-width: 600px) {
  .section {
    flex-direction: column;
    padding: 40px 0 0 0;
  }
  #structure {
    flex-direction: column-reverse;
  }
  .left, .right {
    padding: 0;
  }
}
</style>